import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GenericPageComponent } from './generic-page.component';
import { GenericPageRoutingModule } from './generic-page.routing.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PopupShimmerModule } from '../popup-shimmer/popup-shimmer-module';
import { SharedModule } from '../@shared/shared.module';
import { MatDialogModule } from '@angular/material/dialog';
import { PolicyDetailsModule } from '../policy-details/policy-details.module';

@NgModule({
    declarations: [GenericPageComponent],
    exports: [GenericPageComponent],
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        GenericPageRoutingModule,
        MatProgressSpinnerModule,
        PopupShimmerModule,
        SharedModule,
        MatDialogModule,
        PolicyDetailsModule,
    ],
})
export class GenericPageModule {}
